<template>
  <item-details-container :title="$t('title')" :fields="fields" :basic-information="$t('basicInformation')">
    <v-tab key="optimizations" ripple>{{ $t('optimizations') }}</v-tab>
    <!-- Optimizations -->
    <v-tab-item key="optimizations">
      <v-card flat>
        <v-card-text>
          <!-- path was there to get a single child record with his id -->
          <!-- path="createOpticheckOptimization" -->
          <task-optimizations
            :exclude="['id']"
            child-item-name="optimizations"
            fk-name="task_id"
          ></task-optimizations>
        </v-card-text>
      </v-card>
    </v-tab-item>
  </item-details-container>
</template>

<script>
import ItemDetailsContainer from '@/utils/crud/components/ItemDetailsContainer.vue'
import ItemDetailsContainerMixin from '@/utils/crud/mixins/item-details-container'
import TaskOptimizations from './TaskOptimizationsServer.vue'
// import TaskOptimizations from './TaskOptimizations.vue'

export default {
  mixins: [ItemDetailsContainerMixin],
  components: {
    ItemDetailsContainer,
    TaskOptimizations,
  },
  created () {
    this.setIdColumn('id'),
    this.setChildItemsMapping([
      {
        name: 'optimizations',
        objName: 'optimizations',
        fkName: 'task_id',
        fetchFn: 'listOpticheckOptimizations'
      },
    ])
  },
  i18n: {
    messages: {
      de: {
        title: 'Aufgabendetails',
        basicInformation: 'Standard Informationen',
        optimizations: 'Optimierungen',
      },
      en: {
        title: 'Task details',
        basicInformation: 'Basic information',
        optimizations: 'Optimizations',
      },
    },
  },
}

</script>
